/* ============================================
   RIOBAKER LANDING — JS ASSET
   Archivo: assets/riobaker-landing.js
   ============================================ */

var currentStep = 1;
var selectedService = '';

/* ── SERVICIO ── */
function selectService(btn) {
  document.querySelectorAll('.rb-service-btn').forEach(function(b) {
    b.classList.remove('selected');
  });
  btn.classList.add('selected');
  selectedService = btn.getAttribute('data-value');
  document.getElementById('servicioInput').value = selectedService;
  document.getElementById('formSubject').value = 'Cotización RioBaker — ' + selectedService;
  document.getElementById('btnStep1').disabled = false;
}

/* ── PASOS ── */
function nextStep(from) {
  if (from === 1 && !selectedService) return;
  if (from === 2) {
    var prod = document.querySelector('[name="producto"]');
    var vol  = document.querySelector('[name="volumen"]');
    if (!prod.value.trim() || !vol.value) {
      alert('Por favor completa el tipo de producto y volumen estimado.');
      return;
    }
  }
  hideStep(from);
  showStep(from + 1);
  if (from + 1 === 3) buildResumen();
}

function prevStep(from) {
  hideStep(from);
  showStep(from - 1);
}

function hideStep(n) {
  var el = document.getElementById('step' + n);
  if (el) el.classList.remove('active');
  var dot = document.getElementById('dot' + n);
  if (dot) { dot.classList.remove('active'); dot.classList.add('done'); }
}

function showStep(n) {
  var el = document.getElementById('step' + n);
  if (el) el.classList.add('active');
  var dot = document.getElementById('dot' + n);
  if (dot) { dot.classList.remove('done'); dot.classList.add('active'); }
  currentStep = n;
  updateProgress(n);
  window.scrollTo({ top: document.getElementById('cotizar').offsetTop - 80, behavior: 'smooth' });
}

function updateProgress(step) {
  var fill = document.getElementById('progressFill');
  if (!fill) return;
  var pcts = { 1: '33.33%', 2: '66.66%', 3: '100%' };
  fill.style.width = pcts[step] || '33.33%';
}

/* ── CAMPOS ENVASADO DINÁMICOS ── */
function toggleFormatoEnvasado() {
  var tipo = document.getElementById('tipoEnvasado').value;
  var auto = document.getElementById('opcionesAuto');
  var manual = document.getElementById('opcionesManual');
  if (auto) auto.style.display = tipo === 'Automatico' ? 'block' : 'none';
  if (manual) manual.style.display = tipo === 'Manual' ? 'block' : 'none';
}

/* Mostrar campos de envasado si el servicio es Envasado o Integral */
document.querySelectorAll('.rb-service-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var v = btn.getAttribute('data-value');
    var campos = document.getElementById('camposEnvasado');
    if (campos) {
      campos.style.display = (v === 'Envasado' || v === 'Integral') ? 'block' : 'none';
    }
  });
});

/* ── RESUMEN PASO 3 ── */
function buildResumen() {
  var resumen = document.getElementById('resumenForm');
  if (!resumen) return;
  var prod = document.querySelector('[name="producto"]');
  var vol  = document.querySelector('[name="volumen"]');
  var html = '📋 <strong>Tu solicitud:</strong> ' + selectedService;
  if (prod && prod.value) html += ' · ' + prod.value;
  if (vol && vol.value) html += ' · ' + vol.value;
  resumen.innerHTML = html;
}

/* ── FAQ ── */
function toggleFaq(btn) {
  var answer = btn.nextElementSibling;
  var isOpen = btn.classList.contains('open');
  document.querySelectorAll('.rb-faq-q').forEach(function(b) {
    b.classList.remove('open');
    if (b.nextElementSibling) b.nextElementSibling.classList.remove('open');
  });
  if (!isOpen) {
    btn.classList.add('open');
    if (answer) answer.classList.add('open');
  }
}

/* ── ENVÍO FORMULARIO ── */
document.getElementById('rbForm').addEventListener('submit', function(e) {
  e.preventDefault();
  var btnText    = document.getElementById('btnText');
  var btnLoading = document.getElementById('btnLoading');
  var btnSubmit  = document.getElementById('btnSubmit');

  btnText.style.display    = 'none';
  btnLoading.style.display = 'inline';
  btnSubmit.disabled       = true;

  var formData = new FormData(this);

  fetch(this.action, {
    method: 'POST',
    body: formData,
    headers: { 'Accept': 'application/json' }
  })
  .then(function(res) { return res.json(); })
  .then(function(data) {
    document.querySelectorAll('.form-step').forEach(function(s) { s.style.display = 'none'; });
    document.querySelector('.rb-progress').style.display = 'none';
    window.location.href = '/pages/gracias-por-tu-cotizacion';
  })
  .catch(function() {
    btnText.style.display    = 'inline';
    btnLoading.style.display = 'none';
    btnSubmit.disabled       = false;
    alert('Error al enviar. Por favor intenta de nuevo o contáctanos por WhatsApp.');
  });
});

/* ── SMOOTH SCROLL para links internos ── */
document.querySelectorAll('a[href^="#"]').forEach(function(a) {
  a.addEventListener('click', function(e) {
    var target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});